import type BrazeSdk from '@braze/web-sdk';
import { createContext, useContext } from 'react';

type BrazeContext = {
  Braze?: typeof BrazeSdk;
  isLoading: boolean;
};

const defaultValue: BrazeContext = {
  isLoading: true,
};

const context = createContext(defaultValue);
const { Provider } = context;
const useBraze = (): BrazeContext => useContext(context);

export { BrazeContext, Provider, defaultValue, useBraze };
